export const countries: string[] = ['USA', 'Canada'];
